import { Trans } from '@lingui/macro';
import { tracking } from 'noddi-provider';
import { cn, NoddiDummyButton } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';

export const ReferralCard = ({ className }: { className?: string }) => (
  <NoddiBasicCard
    onClick={() => {
      tracking.track('referralPressedAfterBooking');
    }}
    to={customerRoutes.Discounts.getPath()}
    className={cn('flex flex-col gap-4 bg-lightPurple text-darkPurple', className)}
  >
    <p className='font-bold text-5'>
      <Trans>Enjoying Noddi so far?</Trans>
    </p>

    <p>
      <Trans>Refer a friend and you both get 150 kr in discounts on your next booking</Trans>💜
    </p>

    <div className='flex items-end justify-between'>
      <img className='-mb-2 w-22' src='/assets/svgs/CarryingTires.svg' alt='bg_image' />
      <NoddiDummyButton variant='secondary' startIcon='ArrowSquareRightCorner' size='small'>
        <Trans>Invite a friend</Trans>
      </NoddiDummyButton>
    </div>
  </NoddiBasicCard>
);
